import { ReactNode } from 'react';
import { Link as RouterLink, useMatch } from 'react-router-dom';
import DrawerListItem from 'layout/components/drawer/DrawerListItem';

export type RouterDrawerListItemProps = {
  /**
   * The route to navigate to when clicked. When the URL matches this route, the element is highlighted.
   */
  to: string;
  /**
   * When defined, uses this route for matching instead of `to`.
   */
  matchTo?: string;
  text?: string;
  icon?: ReactNode;
  disabled?: boolean;
  notificationNumber?: number;
};

const RouterDrawerListItem = ({
  to,
  matchTo,
  text,
  icon,
  notificationNumber,
  disabled = false,
}: RouterDrawerListItemProps) => {
  const matchesToRoute = useMatch(`${matchTo ?? to}/*`);
  const selected = Boolean(matchesToRoute);

  return (
    <DrawerListItem
      text={text}
      icon={icon}
      selected={selected}
      disabled={disabled}
      notificationNumber={disabled ? 0 : notificationNumber}
      ListItemButtonProps={{
        component: RouterLink,
        to: to,
      }}
    />
  );
};

export default RouterDrawerListItem;
